import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function postAgent20(params) {
  return authPost(`${baseUrl}/Agent20.ashx`, params);
}
